import React, { useContext, useRef, useState } from "react";
import "./Form.scss";
// import Select from "../Select/Select";
import countries from "../countries";
import county from "../county";
import Select, { components } from "react-select";
import { Formik } from "formik";
import {SquareContext} from "../../SquareContext"

export default function Form(props) {

  const {
    nameForm, setNameForm,
    teleForm, setTeleForm,
    mailForm, setMailForm,
    country, setCountry, countiesNames, counties, countyId, setCountyId, surnameForm, setSurnameForm,addressForm, setAddressForm
  } = useContext(SquareContext)
 

  const textInput = useRef();

  
  const Placeholder = props => {
    return <components.Placeholder {...props} />;
  };

  // const [selectedOption, setSelectedOption] = useState(null);
//   const colourStyles = {
//     placeholder: (defaultStyles) => {
//         return {
//             ...defaultStyles,
//             color: 'black',
//         }
//     }
// }


// const styles = {
//   control: base => ({
//     ...base,
//     fontFamily: "Krub"
//   }),
//   menu: base => ({
//     ...base,
//     fontFamily: "Krub"
//   })
// };



// console.log(countyId)
// console.log(country)

  return (
    <>
      



      {/* <form>
<ul class="form-style-1">
    <li><label>Full Name <span class="required">*</span></label><input type="text" name="field1" class="field-divided" placeholder="First" /> <input type="text" name="field2" class="field-divided" placeholder="Last" /></li>
    <li>
        <label>Email <span class="required">*</span></label>
        <input type="email" name="field3" class="field-long" />
    </li>
    <li>
        <label>Subject</label>
        <select name="field4" class="field-select">
        <option value="" disabled placeholder="Select County">
          
                County
              </option>
              {countries.map((country) => (
                <option key={country}>{country}</option>
              ))}
        </select>
    </li>

    <li>
        <input type="submit" value="Submit" />
    </li>
</ul>
</form> */}

      <div className="form-style">
        <ul>
          <li>
            <input
              type="name"
              name="field1"
              value={nameForm}
              className="field-style field-split align-left"
              placeholder="Name*"
              autoComplete="off"
              onChange={(e) => setNameForm(e.target.value)}
            />
            <input
              type="surname"
              name="field2"
              value={surnameForm}
              className="field-style field-split align-right"
              placeholder="Surname"
              autoComplete="off"
              onChange={(e) => setSurnameForm(e.target.value)}
            />
          </li>
          <li>
            <input
              type="tel"
              name="field3"
              value={teleForm}
              className="field-style field-split align-left"
              placeholder="Telephone Number*"
              onChange={(e) => setTeleForm(e.target.value)}
              autoComplete="off"
            />
            <input
              type="email"
              name="field4"
              value={mailForm}
              className="field-style field-split align-right"
              placeholder="Email*"
              autoComplete="off"
              onChange={(e) => setMailForm(e.target.value)}
             
            />
          </li>

          {/* <li>
            <select
            value={country}
            key={countyId}
              name="country"
              // value={country}
              className="field-style field-full align-none field-select "
              placeholder="County"
              onChange={(e) => {
                setCountry(e.target.value);
                setCountyId(counties.find((el) => el.name === e.target.value))
              }}
              required
            >
              <option value="" disabled  >
                 
                County*
              </option>
              {counties.map((el) => (
                <option key={el.id}>{el.name}</option>
              
              ))}
            </select>
          </li> 
           */}
          

          <Select
          className="select"
          components={{ Placeholder }}
          
         value={country === "" ? {label: "County*"} : {label: country} }
         ref={textInput}
          name="country"
          placeholder={'County*'}
        onChange={(e) => {
          setCountry(e.value);
          setCountyId(counties.find((el) => el.name ===  e.value))

      
        }}
        required
      
        options={counties.map((el) => (
          { value: el.name, label: el.name }
        ) )}
          

        styles={{
          placeholder: base => ({
            ...base,
            fontSize: 'small',
            color: "black !important",
            fontWeight: 500,
            
          }),
        }}

        theme={theme => ({
          ...theme,
          borderRadius: 15,
          colors: {
            ...theme.colors,
            primary25: 'rgba(255, 38, 45, 0.765)',
            primary: '#d9d9d9',
          },
        })}

      />

     


          <li>
            <input
            value={addressForm}
              type="text"
              name="field5"
              className="field-style field-full align-none"
              placeholder="Full Address"
              autoComplete="off"
              onChange={(e) => setAddressForm(e.target.value)}
            />
          </li>
          {/* <li>
            <textarea
              name="field5"
              class="field-style-message"
              placeholder="Message"
            ></textarea>
          </li> */}
          {/* <li>
                        <input type="submit" value="Send Message" />
                      </li> */}
        </ul>
      </div>
       
    </>
  );
}
